import { DrawingManager } from '@react-google-maps/api';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import deliveryZonesStore from '../../stores/deliveryZonesStore';
import { DELIVERY_ZONE_TYPE } from 'src/types/deliveryManagment';
import { CoordsBounds } from 'src/types/main';

const DeiveryZoneDrawingTools = observer(() => {
  const onPolygonComplete = useCallback((polygon: google.maps.Polygon) => {
    //   Get bounds from polygon
    const bounds: CoordsBounds = polygon
      .getPath()
      .getArray()
      .map((latLng) => [latLng.lat(), latLng.lng()]);
    // remove polygon from map
    polygon.setMap(null);
    // update draft zone bounds
    deliveryZonesStore.editDraftZone('bounds', bounds);
    // if (deliveryZonesStore.draft?.type === DELIVERY_ZONE_TYPE.PLYGON) {
    //   deliveryZonesStore.checkBranchCoverage();
    // }
  }, []);
  // if draft if not available do not start
  if (!deliveryZonesStore.draft) return null;
  // if draft type is not polygon or bounds already exist do not start
  if (deliveryZonesStore.draft?.type !== DELIVERY_ZONE_TYPE.PLYGON || deliveryZonesStore.draft?.bounds.length) return null;
  return (
    <>
      {deliveryZonesStore.draft.branch ? (
        <DrawingManager
          options={{ drawingControl: false }}
          onPolygonComplete={onPolygonComplete}
          drawingMode={google?.maps?.drawing?.OverlayType.POLYGON}
        />
      ) : null}
    </>
  );
});

export default DeiveryZoneDrawingTools;
